import { ERestoreEntityType } from '@/enum';
import { IAddClassPayload } from '@/types/payload';
import { formatQuery } from '@/utils';

import http from './http';
import serviceHelper from './serviceHelper';

export const getClassList = async (query?: Record<string, unknown>) => {
  const queryString = query ? formatQuery(query) : '';
  return serviceHelper(http.get(`/school/class?${queryString}`), false);
};

export const getClassDetails = async (id: string) => {
  return serviceHelper(http.get(`/school/class/${id}`), false);
};

export const addClass = async (payload: IAddClassPayload) => {
  return serviceHelper(http.post('/school/class', payload), true);
};

export const updateClass = async (id: string, payload: IAddClassPayload) => {
  return serviceHelper(http.patch(`/school/class/${id}`, payload), true);
};

export const removeClass = async (id: string) => {
  return serviceHelper(
    http.delete(
      `/school/restore/${id}?record_type=${ERestoreEntityType.CLASS}`
    ),
    true
  );
};

export const getClassDropdown = async (exclude_block?: boolean) => {
  return serviceHelper(
    http.get('/school/class/dropdown', {
      params: { exclude_block },
    }),
    false
  );
};

export const getClassTeacherAndSummary = async (classId: string) => {
  return serviceHelper(
    http.get(`/school/classes/teacher-and-summary/${classId}`),
    false
  );
};

export const getClassStudents = async (
  classId: string,
  query?: Record<string, unknown>
) => {
  const queryString = query ? formatQuery(query) : '';
  const url = queryString
    ? `/school/class/${classId}/students?${queryString}`
    : `/school/class/${classId}/students`;

  return serviceHelper(http.get(url), false);
};

export const getStudentAnalytics = async (query?: Record<string, unknown>) => {
  const queryString = query ? formatQuery(query) : '';
  return serviceHelper(
    http.get(`/school/analytics/student?${queryString}`),
    false
  );
};

export const getTeacherAnalytics = async (query?: Record<string, unknown>) => {
  const queryString = query ? formatQuery(query) : '';
  return serviceHelper(
    http.get(`/school/analytics/teacher?${queryString}`),
    false
  );
};

export const getStudentDetails = async (studentId: string) => {
  return serviceHelper(http.get(`/school/student/${studentId}`), false);
};

export const getClassAnalytics = async (query?: Record<string, unknown>) => {
  const queryString = query ? formatQuery(query) : '';
  return serviceHelper(
    http.get(`/school/analytics/class?${queryString}`),
    false
  );
};

export const exportAnalyticsData = async (query?: Record<string, unknown>) => {
  const queryString = query ? formatQuery(query) : '';
  return serviceHelper(
    http.get(
      `/school/analytics/export${queryString ? '?' + queryString : ''}`,
      {
        responseType: 'blob',
      }
    ),
    false
  );
};

export const getTeacherClassDropdown = async (exclude_block?: boolean) => {
  return serviceHelper(
    http.get('/teacher/class/dropdown', {
      params: { exclude_block },
    }),
    false
  );
};

export const getTeacherClassList = async (query?: Record<string, unknown>) => {
  const queryString = query ? formatQuery(query) : '';
  return serviceHelper(http.get(`/teacher/class?${queryString}`), false);
};

export const getTeacherClassSummary = async () => {
  return serviceHelper(http.get('/teacher/class/summary'), false);
};

export const getTeacherClassDetails = async (id: string) => {
  return serviceHelper(http.get(`/teacher/class/${id}`), false);
};

export const getTeacherClassStudents = async (
  classId: string,
  query?: Record<string, unknown>
) => {
  const queryString = query ? formatQuery(query) : '';
  return serviceHelper(
    http.get(`/teacher/class/${classId}/students?${queryString}`),
    false
  );
};

export const getTeacherClassLessonBreakDownList = async (query?: string) => {
  return serviceHelper(
    http.get(`teacher/class/see-more/lesson?${query}`),
    false
  );
};

export const getTeacherClassLessonChart = async (classId: string) => {
  return serviceHelper(
    http.get(`/teacher/class/${classId}/lesson-chart`),
    false
  );
};
